import { atom } from 'jotai'

/**
 * Atom representing the current page of the convertible grid.
 */
export const convertibleGridCurrentPageAtom = atom(0)

/**
 * Atom representing the active tab in the convertible section.
 */
export const convertibleActiveTabAtom = atom('current')

/**
 * Atom representing the search text input in the convertible section.
 */
export const convertibleSearchTextfieldAtom = atom('')
